import SVG from "../../../Components/SVG";
import { Tooltip } from "react-tooltip";
export default function Back({ onClick = () => {} }) {
  return (
    <div className="relative h-full pr-3 flex items-center justify-center border-r border-r-zi-border-light dark:border-r-0">
      <div className="card-divider absolute inset-y-0 right-0 hidden w-px shrink-0 self-stretch bg-[linear-gradient(180deg,transparent,rgba(255,255,255,0.09)_20%,rgba(255,255,255,0.22)_50%,rgba(255,255,255,0.09)_80%,transparent)] dark:block" />
      <button
        type="button"
        onClick={() => {
          if (onClick) {
            onClick();
            return;
          }
          window.history.back();
        }}
        data-tooltip-id="backTooltip"
        data-tooltip-content="بازگشت"
      >
        <SVG
          name="back"
          classname="size-5 cursor-pointer stroke-zi-blue-dark dark:stroke-white"
        />
      </button>

      <Tooltip
        id="backTooltip"
        place="bottom"
        className="z-50 !py-1 !px-2 !text-xs !font-thin !backdrop-blur !bg-cyan-600 !rounded-lg"
      />
    </div>
  );
}
